import { FunctionalComponent } from 'preact';

import { useEffect } from 'preact/hooks';
import clsx from 'clsx';
import { IconSource, toIconElement } from '@accedo/ctv-ui-icons';
import { SplashCssModule, SplashProps } from '##/components/SplashScreen/types';
import NZOSFullLogo from '##/assets/images/svg/NZOSFullLogo.svg';
import defaultStyles from './SplashScreen.module.scss';

export const SplashScreen: FunctionalComponent<SplashProps> = ({ logo, styling }) => {
  const styles = styling && styling.cssModule ? styling.cssModule : (defaultStyles as unknown as SplashCssModule);
  const logoSrc = logo && logo.src ? logo.src : NZOSFullLogo;
  const logoAttributes =
    logo && logo.attributes
      ? logo.attributes
      : {
          viewBox: '0 0 1920 1080',
        };

  useEffect(() => {
    // useEffect (not useLayoutEffect) ensures the browser has already painted the
    // dynamic splash before the static HTML splash is removed. useLayoutEffect fires
    // before paint, which on slow devices (Android, LG, Tizen) causes a visible gap
    // where neither splash is on screen for a brief moment.
    let staticSplash = document.getElementById('static-splash');

    /* Removes the static splash when the js bundle is loaded in the client. */
    if (staticSplash) {
      document.body.removeChild(staticSplash);
      staticSplash.remove();
      staticSplash = null;
    }
  }, []);

  return (
    <div
      id="splash-screen"
      key="splash-screen"
      className={clsx(styles.splashContainer, styling?.className)}
      style={styling?.inlineStyle}
    >
      {toIconElement(logoSrc as IconSource, { attributes: logoAttributes })}
    </div>
  );
};
